import './SearchHeader.scss'

import { HDSButton } from '@here/hds-react-components'
import { CloseButton } from 'components/App'
import { IzumiMessageKey } from 'izumi/IzumiMessageKey'
import { i18n } from 'lib/i18n'
import React from 'react'

export interface SearchHeaderProps {
  title: string
  onClose?: () => void
  onEdit?: () => void
}

export default function SearchHeader({ title, onClose, onEdit }: SearchHeaderProps): JSX.Element {
  const editLink = i18n('link.edit' as IzumiMessageKey)

  const handleCloseButton = (): void => {
    if (onClose !== undefined) {
      onClose()
    }
  }

  const handleEditLink = (): void => {
    if (onEdit !== undefined) {
      onEdit()
    }
  }

  return (
    <div className="SearchHeader">
      <div className="SearchHeader__title">
        <span>{title}</span>
        <CloseButton onClick={handleCloseButton} />
      </div>

      <HDSButton variant="link" onClick={handleEditLink}>
        {editLink}
      </HDSButton>
    </div>
  )
}
